// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-modal-body {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: white;
  border-radius: 0.6vw;
  padding: 0.8vw;
  outline: none;
  border: none;
  width: 40vw !important;
  height: 40vw !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/modals/imageModal/imageStyle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".image-modal-body {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background-color: white;\n  border-radius: 0.6vw;\n  padding: 0.8vw;\n  outline: none;\n  border: none;\n  width: 40vw !important;\n  height: 40vw !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
